import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationCancel, NavigationError, ResolveStart } from '@angular/router';
import 'whatwg-fetch';
import { AccessibilityService } from './shared/services/accessibility.service';
import { LookupService } from 'src/app/shared/services/lookup.service';
import { VersionCheckService } from './shared/services/version-check.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

declare let gtag: Function;

@Component({
  selector: 'online-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
  
export class AppComponent implements OnInit {

  title = 'online-app';
  className: string;

  googleAnalyticsKey: string;
  
  constructor(private router: Router,
    private accessibilityService: AccessibilityService,
    private lookupService: LookupService,
    private ngxUiSpinnerService: NgxUiLoaderService,
    private versionCheckService: VersionCheckService)
  {
    // Init the version.json polling. The service keeps polls and finds if the a new version is released. 
    this.versionCheckService.initVersionCheck();

    this.lookupService.getGASettings().subscribe((response: any) => {
      this.googleAnalyticsKey = <string>response;
      //console.log('googleAnalyticsKey is: ', this.googleAnalyticsKey);
    });

    this.router.events.subscribe((event) => {

      this.accessibilityService.addLoadingAttr();
      
      if (event instanceof ResolveStart) {
        // console.log(`navigation start - ${event.url}`);
        /* showing or hiding of spinner is handled in NgxUiLoaderRouterModule */
        //append <span class="startloading" style="color: #000">Start loading</span> in loading icon html
        this.ngxUiSpinnerService.start('route-change');
        this.accessibilityService.startloadingAccessibility();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError) {

        // console.log(`navigation end - ${event.url}`);
        /* showing or hiding of spinner is handled in NgxUiLoaderRouterModule */
        //append <span class='dataloaded' style='color: #000'>Data loaded</span> in loading icon html
        this.ngxUiSpinnerService.stop('route-change');
        this.accessibilityService.loadedAccessibility();        
      }


      //2020-02 Add GA
      if (event instanceof NavigationEnd) {
        if (this.googleAnalyticsKey) {
          gtag('config', this.googleAnalyticsKey,
            {
              'page_path': event.urlAfterRedirects
            }
          );     
        }     
      }

    });
  }

  ngOnInit(){
    this.accessibilityService.currentResizeFont.subscribe((serviceClassName: string) => {
      this.className = serviceClassName;
    });
  }
}
